export const sortPositionNames = (positions) => {
  return positions.sort((a, b) =>
    a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
  );
};

// Creates unique ID for role>
export const serializeRoleId = (role) => `${role.id}--${role.name}`;
